import axios from 'axios';
import { AdminTab } from 'borispage/common/admin-tab';
import { ACTION_TYPE } from 'definitions/ActionType';
import { DOC_TYPE, DocType } from 'definitions/DocType';
import { DocViewType } from 'definitions/DocViewType';
import { LoginType } from 'definitions/LoginType';
import { MENU_TYPE } from 'definitions/MenuType';
import { SiteLanguageType } from 'definitions/SiteLanguageType';
import { i18ns } from 'language/i18nkey';
import { IfLoginInfo } from 'models/IfLoginInfo';
import { IfChkDocTagListEntry } from 'models/IfTagListEntity';
import queryString from 'query-string';
import { ICategoryMap } from 'repositories/category/CategoryRepository';
import {
  ALL_DOCTYPE_OF_DOCUMENT_TAB,
  ALL_DOCTYPE_OF_TECHNICAL_DOCUMENT_TAB,
  emptySsqDataDocument,
  ICreateLogItem,
  IPartnerDocHistoryCreateRequest,
  ISsqDataCreatePartnerDoc,
  ISsqDataDocument,
  ISsqDataDocumentAdminPopup,
  IVersion,
  LEVEL_SELECT,
  NO_VERSION_TAG,
} from 'repositories/SsqDataRepository';
import svcs from 'services';
import { loginutil } from 'util/loginutil';
import { CMMNTY_WRITE_PAGE_TYPE, DOC_GRP } from './docwrite-common';

/**
 * 읽기 전용 필드를 결정하기 위한 함수 .
 */

export type RO_ID =
  | 'public'
  | 'doc-type'
  | 'doc-sub-type'
  | 'site-lang'
  | 'disp-target'
  | 'title'
  | 'body'
  | 'attach-file'
  | 'tag'
  | 'lsrelated'
  | 'linkUrl'
  | 'inquiryCate'
  | 'inquiryType';
export const doc_ro = (docId: number | undefined, pageType: CMMNTY_WRITE_PAGE_TYPE, id: RO_ID): boolean => {
  //const {pageType} = this.state;
  if (pageType === 'APPROVAL') {
    return true;
  } else if (pageType === 'NEW') {
    if (docId > 0) {
      if (id === 'doc-type') return true;
      if (id === 'doc-sub-type') return false;
      if (id === 'site-lang') return true;
      if (id === 'inquiryCate') return true;
      if (id == 'inquiryType') return true;
    }
  }
  return false;
};

export const docwriteutil = {
  isProductCategory: function (categoryId: number, categoryMap: ICategoryMap) {
    if (categoryId === LEVEL_SELECT) {
      return true;
    }

    if (categoryMap && categoryMap[categoryId]) {
      return true;
    }

    return false;
  },
  getTitlePlaceholderText: function (lang: string) {
    switch (lang) {
      case SiteLanguageType.KO_KR:
        return '제목 (한국어, 80자 이하 텍스트)';
      case SiteLanguageType.EN:
        return 'Title (English, 80 characters or less)';
      case SiteLanguageType.EN_US:
        return 'Title (English, 80 characters or less)';
      default:
        return '';
    }
  },
  getTitleLimit(lang: string) {
    if (lang === SiteLanguageType.KO_KR) {
      return 80;
    } else if (lang === SiteLanguageType.EN) {
      return 80;
    } else if (lang === SiteLanguageType.EN_US) {
      return 80;
    }
    return 0;
  },
  isUseVersion(versions: IVersion[]) {
    if (versions.length <= 0) return false;
    if (versions.length === 1 && versions[0].version === NO_VERSION_TAG) {
      return false;
    }
    return true;
  },
  getadmintrans(key: string): string {
    svcs.svcLang.setNamespace(i18ns.admin);
    return svcs.svcLang.getTranslationByKey(key) || '';
  },
  lang(doc: ISsqDataDocumentAdminPopup): string {
    if (doc?.exposeSiteLanguage) return doc.exposeSiteLanguage;
    return svcs.svcLang.lang();
  },
  async saveLog(menuType: MENU_TYPE, actionType: ACTION_TYPE, doc: ISsqDataDocumentAdminPopup) {
    const postLogItem: ICreateLogItem = {
      userId: 'Set In BFF',
      userName: 'Set In BFF',
      nickName: 'Set In BFF',
      menuType,
      actionType,
      logContent: JSON.stringify(doc),
      updateTime: new Date(),
    };
    console.log('craete log ', postLogItem);
    await svcs.repoSsqData.postMemberLogItem(postLogItem);
  },

  async savePartnerLog(docId: number, userId: string, doc: ISsqDataCreatePartnerDoc) {
    const postPartnerLogItem: IPartnerDocHistoryCreateRequest = {
      partnerLog: JSON.stringify(doc),
      docId: Number(docId),
      updateUserId: userId,
    };
    (await axios.post('/api/member/partner/doc/save/log', postPartnerLogItem)).status;
  },

  async saveTemp(inputDoc, viewType, docId, tempId, tags: { taglist; prods; apploads; industs; doctypes }) {
    let doc: any = { ...inputDoc };
    doc.tags = tags;
    const res = await svcs.repoSsqData.saveTemporaryData2(JSON.stringify(doc), docId, tempId, viewType);

    //console.log("save result ", res);
    return res;
  },

  getPreviewDoc: (inputDoc: ISsqDataDocumentAdminPopup, inputVer: IVersion, isUseVersionManagement: boolean) => {
    const getDownloadVersionInNoVersion = (inputVer: IVersion) => {
      return inputVer.files.length > 0 ? [inputVer] : [];
    };

    const doc: ISsqDataDocument = {
      ...emptySsqDataDocument,
      id: inputDoc.id,
      docTitle: inputDoc.docTitle,
      description: inputDoc.description,
      docType: inputDoc.docType,
      docLanguages: [],
      writerId: inputDoc.writerId,
      writerNickname: '',
      updateTime: new Date(),
      clickCount: 0,
      admission: inputDoc.admission,
      parentId: inputDoc.parentId,
      versions: isUseVersionManagement ? inputDoc.versions : getDownloadVersionInNoVersion(inputVer),
      categories: inputDoc.categories,
      productCategoryNames: [],
      imageUrl: '',
      displayTarget: inputDoc.displayTarget,
      exposeSiteLanguage: inputDoc.exposeSiteLanguage,
    };

    return doc;
  },
};

export const reduceCheckedTagList = (tot: number, taglist: Array<IfChkDocTagListEntry>) => {
  if (tot > 100) {
    let cnt = tot - 100;
    let list = taglist.slice().reverse();
    list.forEach((ele) => {
      if (cnt <= 0) return;
      if (ele.checked) {
        ele.checked = false;
        cnt--;
      }
    });
  }
};

/*
글쓰기 페이지의 경우, 신규, 임시, 승인 의 형태가 있음. 
*/
export const getPageType = (path: string): CMMNTY_WRITE_PAGE_TYPE => {
  let pageType: CMMNTY_WRITE_PAGE_TYPE = 'NEW';
  if (path.startsWith('/community/temp/') || /^\/\w\w\/\w\w\/community\/temp\//.test(path)) pageType = 'TEMP';
  if (path.startsWith('/community/approval/') || /^\/\w\w\/\w\w\/community\/approval\//.test(path))
    pageType = 'APPROVAL';
  return pageType;
};

export const getInputLinkUrl = (inputDoc: ISsqDataDocumentAdminPopup): string | undefined => {
  if (!inputDoc) return '';
  if ((inputDoc.linkUrl2 || inputDoc.linkUrl1 || inputDoc.linkUrl3 || inputDoc.linkUrl4) == undefined) {
    return ((inputDoc.linkUrl2 = ''), (inputDoc.linkUrl1 = ''), (inputDoc.linkUrl3 = ''), (inputDoc.linkUrl4 = ''));
  } else {
    return inputDoc.linkUrl;
  }
};

export const compareVersionDesc = (v1: string, v2: string): number => {
  const nums1 = (v1 ?? '').match(/\d+/g)?.map(Number) ?? [];
  const nums2 = (v2 ?? '').match(/\d+/g)?.map(Number) ?? [];
  for (let i = 0; i < Math.max(nums1.length, nums2.length); i++) {
    const diff = (nums2[i] ?? 0) - (nums1[i] ?? 0);
    if (diff !== 0) return diff;
  }
  return 0;
};

export const getEmptyVersion = (isUseVersionManagement: boolean): IVersion => {
  if (isUseVersionManagement) {
    return { version: '', versionDescription: '', files: [] };
  } else {
    return { version: NO_VERSION_TAG, versionDescription: '', files: [] };
  }
};

export const handleError401 = () => {
  const trans = docwriteutil.getadmintrans;
  alert(trans('I18N_SESSION_INVALIDATE'));
};

export const getViewType = (loginInfo: IfLoginInfo) => {
  const sitelang = svcs.svcLang.lang();
  // lse 인 경우, ALLDOC 반환.
  if (loginutil.islse(loginInfo)) return DocViewType.ALLDOC;
  return sitelang;
};

export const getDocTypeByDocGrp = (docgrp: DOC_GRP, loginType: string) => {
  let docType: string;
  if (docgrp === 'blog') {
    docType = DocType.TECH_GENERAL;
  } else if (docgrp === 'appnote') {
    docType = DocType.APPLICATION_NOTE;
  } else if (docgrp === 'info') {
    docType = DocType.DOC_NOTI;
  } else if (docgrp === 'qna') {
    docType = DocType.QNA_Q;
  } else if (docgrp === 'sample') {
    docType = DocType.USER_SAMPLE;
  } else if (docgrp === 'doc') {
    docType = DocType.MANUAL;
  } else if (docgrp === 'rndnoti') {
    docType = DocType.RND_NOTI;
  } else if (docgrp === 'rndqna') {
    docType = DocType.RND_QNA_Q;
  } else if (docgrp === 'rndtalk') {
    docType = DocType.RND_TALK;
  } else if (docgrp === 'partnernoti') {
    docType = DocType.PARTNER_NOTI;
  } else if (docgrp === 'partnerqna') {
    docType = DocType.PARTNER_QNA_Q;
  } else {
    if (loginType === LoginType.LOGIN_TYPE_WELS) {
      docType = DocType.MANUAL; // 기본.
    } else {
      docType = DocType.QNA_Q; // 기본.
    }
  }
  return docType;
};

export const getDocGrpByDocType = (docType: DOC_TYPE): DOC_GRP => {
  if (docType === DocType.TECH_GENERAL) {
    return 'blog';
  } else if (docType === DocType.APPLICATION_NOTE) {
    return 'appnote';
  } else if (docType === DocType.TIP) {
    return 'info';
  } else if (docType === DocType.QNA_Q) {
    return 'qna';
  } else if (docType === DocType.USER_SAMPLE) {
    return 'sample';
  } else if (docType === DocType.MANUAL) {
    return 'doc';
  } else if (docType === DocType.RND_NOTI) {
    return 'rndnoti';
  } else if (docType === DocType.RND_QNA_Q) {
    return 'rndqna';
  } else if (docType === DocType.RND_TALK) {
    return 'rndtalk';
  } else if (docType === DocType.PARTNER_NOTI) {
    return 'partnernoti';
  } else if (docType === DocType.PARTNER_QNA_Q) {
    return 'partnerqna';
  } else {
    throw new Error(`getDocGrpByDocType: ${docType} is not supported`);
  }
};

export const getAdminTabByApprovalDocType = (docType: DOC_TYPE): AdminTab => {
  if ((ALL_DOCTYPE_OF_DOCUMENT_TAB as string[]).includes(docType)) return 'doc';
  if ((ALL_DOCTYPE_OF_TECHNICAL_DOCUMENT_TAB as string[]).includes(docType)) return 'tech';
  console.warn(`getAdminTabByApprovalDocType: unexpected docType "${docType}", falling back to 'doc'`);
  return 'doc';
};

export const getdocgrp = (search: string) => {
  const qs = queryString.parse(search);
  return qs.docgrp as DOC_GRP;
};

export const getQueryLang = (search: string) => {
  const qs = queryString.parse(search);
  return qs.lang as string;
};

export const getQueryCopyId = (search: string) => {
  const qs = queryString.parse(search);
  return qs.copyid as string;
};

export const getshowCommentPopup = (search: string) => {
  const qs = queryString.parse(search);
  return qs.showCommentPopup == 'false' ? false : true;
};
